import Axios from 'axios';

const axiosErrorOf = (err: any) => err?.connectorError ?? err;

export const getErrorStatus = (err: any): number | undefined => axiosErrorOf(err)?.response?.status;

export const getErrorRequest = (err: any): string | undefined => {
	const config = axiosErrorOf(err)?.config;

	if (!config) return undefined;

	const url = new URL(Axios.getUri({ ...config, params: undefined }), window.location.origin);

	return `${(config.method || 'get').toUpperCase()} ${decodeURIComponent(url.pathname)}`;
};
